<div
  cdkDrag
  cdkDragBoundary=".cdk-overlay-container"
  cdkDragRootElement=".cdk-overlay-pane"
  class="not-see-through"
  class="dialogDragContainer"
>
  <div mat-dialog-title class="fsInvestigateHeader">
    <div class="titleFormWrapper">
      <div class="fsInvestigateTitle">Whooster</div>
      <div class="minimizedWrapper" *ngIf="isMinimized">
        <button
          matTooltip="Maximize"
          class="maximizeBtn"
          mat-icon-button
          (click)="toggleMinimize()"
        >
          <sn-icon fontSet="fal" fontIcon="fa-arrows-maximize"></sn-icon>
        </button>
        <sn-icon cdkDragHandle class="draggable">drag_indicator</sn-icon>
      </div>
      <div class="minimizedWrapper" *ngIf="!isMinimized">
        <button
          matTooltip="Minimize"
          class="minimizeBtn"
          mat-icon-button
          (click)="toggleMinimize()"
        >
          <sn-icon fontSet="fal" fontIcon="fa-arrows-minimize"></sn-icon>
        </button>
        <sn-icon cdkDragHandle class="draggable">drag_indicator</sn-icon>
      </div>
    </div>
  </div>
  <mat-dialog-content>
    <mat-tab-group #tabs>
      <mat-tab label="Search">
        <div class="whoosterContent">
          <div *ngIf="!search && !isLoading">
            <div *ngIf="addressParam">
              <hr />
              <div class="itemRow">
                <span class="searchParams"
                  >{{ addressParam.searchParams.address }}, {{ addressParam.searchParams.city }},
                  {{ addressParam.searchParams.state }} {{ addressParam.searchParams.zip }}</span
                >
                <sn-flat-button class="searchButton" color="accent" (click)="addressSearch()"
                  >Search</sn-flat-button
                >
              </div>
              <hr />
            </div>
            <div *ngIf="!addressParam && invalidAddress">
              <div class="errorMsg">
                <span class="searchParams">{{ invalidAddress }}</span>
              </div>
              <hr />
              <form [formGroup]="form">
                <sn-form
                  class="searchbar"
                  [form]="form"
                  [fields]="formFields"
                  [(model)]="formModel"
                ></sn-form>
              </form>
              <sn-flat-button class="searchButton" (click)="addressValidSearch()"
                >Search</sn-flat-button
              >
              <hr />
            </div>
            <div *ngIf="phoneParam">
              <hr />
              <div class="itemRow">
                <p class="searchParams">{{ phoneParam.searchParams.phoneNumber }}</p>
                <sn-flat-button class="searchButton" color="accent" (click)="phoneSearch()"
                  >Search</sn-flat-button
                >
              </div>
              <hr />
            </div>
          </div>
          <div *ngIf="search && isLoading" class="spinner_div">
            <mat-progress-spinner
              color="accent"
              diameter="48"
              mode="indeterminate"
            ></mat-progress-spinner>
          </div>
          <div *ngIf="search && !isLoading && !this.invalidParams">
            <p *ngIf="search === 'address' && addressParam" class="searchTitle">
              {{ addressParam.searchParams.address }}, {{ addressParam.searchParams.city }},
              {{ addressParam.searchParams.state }} {{ addressParam.searchParams.zip }}
            </p>
            <p *ngIf="search === 'phone' && phoneParam" class="searchTitle">
              {{ phoneParam.searchParams.phoneNumber }}
            </p>
            <hr />
            <sn-whooster-address-table
              *ngIf="search === 'address' && addressArray.length > 0"
              [columns]="addressColumns"
              [items]="addressArray"
              (whoosterDownload)="whoosterPdf($event)"
            >
              ></sn-whooster-address-table
            >
            <sn-whooster-phone-table
              *ngIf="search === 'phone' && phoneArray.length > 0"
              [columns]="phoneColumns"
              [items]="phoneArray"
              (whoosterDownload)="whoosterPdf($event)"
            >
              ></sn-whooster-phone-table
            >
            <sn-empty-state
              *ngIf="search === 'address' && !(addressArray?.length > 0)"
              icon="cancel_presentation"
              title="No Results"
            >
              No results for address
            </sn-empty-state>
            <sn-empty-state
              *ngIf="search === 'phone' && !(phoneArray?.length > 0)"
              icon="cancel_presentation"
              title="No Results"
            >
              No results for phone number
            </sn-empty-state>
          </div>
          <div *ngIf="search && !isLoading && this.invalidParams">
            <sn-empty-state *ngIf="this.invalidAddress" icon="error" title="Invalid Search">
            </sn-empty-state>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="History">
        <sn-whooster-history-table
          [columns]="historyColumns"
          [items]="searchHistory"
          (searchParam)="searchParam($event)"
        >
          ></sn-whooster-history-table
        >
        <sn-empty-state
          *ngIf="!searchHistory?.length"
          icon="cancel_presentation"
          title="No Results"
        >
          No results
        </sn-empty-state>
      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button *ngIf="search" color="accent" mat-button (click)="back()">back</button>
    <button color="warn" mat-button mat-dialog-close>close</button>
  </mat-dialog-actions>
</div>
